import { $ } from "@olmokit/dom";
import Olmoforms from "@olmokit/core/olmoforms/feedback";
import Dependency from "@olmokit/core/olmoforms/dependency";
import FormsInputMaterial from "@olmokit/core/forms/input/material";
import FormsSelectMaterial from "@olmokit/core/forms/select/material";
import "@olmokit/core/forms/checkbox";
import "@olmokit/core/forms/textarea/filled";
import { dataLayerForm, salesforceCommunication } from "components/Datalayer";
import "./index.scss";

/**
 * Component: FormProfessional2
 *
 */
export function FormProfessional2() {

  const olmoform = Olmoforms(".Contacts:professional2", {
    sent: (formData) => {
      dataLayerForm("form sent", formData, "Form Professional", $('#of-2-profession').value, $('#of-2-requesttype').value);
      salesforceCommunication(formData, "Form Professional", $('#of-2-profession').value, $('#of-2-requesttype').value);

      const nav = $(".Contacts:nav");
      nav.style.display = 'none';
    }
  });

  FormsInputMaterial();
  FormsSelectMaterial();
  Dependency(".Contacts:professional2");
  
  return {
    destroy() {
      olmoform.destroy();
    },
  };

}
